// src/App.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { AuthProvider } from "./AuthContext";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <div className="App">
        <Header />
        <Outlet />
        <Footer />
      </div>
    </AuthProvider>
  );
};

export default App;
